import { motion } from 'framer-motion';
import React from 'react';
import { fadeLeft, fadeUp } from '../../utils/scrollAnimations';
import ContactDetails from './components/ContactDetails';
import './ReachUs.css';

const ContactDetailsSection = () => {
	const contactDetails = [
		{
			id: 1,
			iconSrc: `${process.env.PUBLIC_URL}/assets/img/call-icon.svg`,
			title: 'Give us a call',
			description: '020-3053 7800',
                        email:"",
companyName:"",
            CIN:"",
		},
		{
			id: 2,
			iconSrc: `${process.env.PUBLIC_URL}/assets/img/mail-icon.svg`,
			title: 'Send us an email',
			description: 'customercare.jcipl@japfa.com',
                        email:"",
companyName:"",
            CIN:"",
		},
		{
			id: 3,
			iconSrc: `${process.env.PUBLIC_URL}/assets/img/location-icon.svg`,
			title: 'Registered office address',
			description:
				'Plot No. 91, Sakore Nagar, Viman Nagar, Pune - 411014',
                        email:"",
companyName:"Japfa Comfeed India Private Limited",
            CIN:"U01222PN1995PTC167653",
		},
                {
           
                        id: 4,
                        iconSrc: `${process.env.PUBLIC_URL}/assets/img/mail-icon.svg`,
                        title: 'Grievance Officer',
                        description:
                        'Vidyasagar Appukuttan',
                        email:'vidyasagar.a@japfa.com',
 companyName:"",
            CIN:"",
 
        }
	];

	return (
		<div className="reachus-contact-deails--wrapper mx-auto max-w-japfaGrid rounded-[20px] px-10 py-12 max-mediumScreen:mx-6 sm:p-20 lg:p-28">
			<motion.h2
				className="relative z-10 mb-6 text-3xl font-extrabold leading-normal text-white md:text-4xl"
				variants={fadeUp}
				initial={'hidden'}
				whileInView="visible"
				viewport={{ once: true }}
			>
				Contact Information
			</motion.h2>
			<motion.div
				className="relative z-10 flex flex-wrap md:flex-nowrap gap-[40px] sm:gap-20"
				variants={fadeLeft}
				initial={'hidden'}
				whileInView="visible"
				viewport={{ once: true }}
			>
				{contactDetails.map((item) => (
					<ContactDetails
						key={item.id}
						description={item.description}
						iconSrc={item.iconSrc}
						title={item.title}
                                                email={item.email}
companyName={item.companyName}
                        CIN={item.CIN}
					/>
				))}
			</motion.div>
		</div>
	);
};


export default ContactDetailsSection;

